import useBeautyFilterStore from 'stores/beautyFilter/beautyFilterStore';

const useMood = () => {
  const store = useBeautyFilterStore();
  const { selectedItem: selectedMenuItem } = store.menu;
  const { keys, table, selectedKey, setSelectedKey, resetSelectedKey } = store.mood;

  const isTabVisible = selectedMenuItem.id === 'mood';

  const isItemSelected = (key: string): boolean => selectedKey === key;

  return {
    keys,
    table,
    isTabVisible,
    isItemSelected,
    handleItemSelect: setSelectedKey,
    handleItemAllReset: resetSelectedKey,
  };
};

export default useMood;
